import React, { FC, useMemo } from 'react'

import styled from 'styled-components'

import { Icon, Tooltip, Txt } from 'src/components/atoms'

import { useGetUsers } from 'src/hooks'
import { formatDate } from 'src/libs/date'
import { getFileSize } from 'src/libs/helper'
import { CommonContentAssetEntity } from 'src/types'

const Container = styled.button`
  transition: all 0.2s ease-in-out;
  outline: none;
`

type Props = {
  asset: CommonContentAssetEntity
  className?: string
}

export const CommonContentAssetInformation: FC<Props> = ({ asset, className }) => {
  const { users } = useGetUsers()

  const updatedBy = useMemo(() => {
    return users.find(user => user.id === asset.uploadedById)
  }, [users, asset.uploadedById])

  return (
    <div className={className}>
      <Tooltip
        placement="top"
        content={
          <div>
            <Txt sizeType="s">
              <span className="tw-text-standardText-secondary">更新者：</span>
              {updatedBy?.email}
            </Txt>
            <Txt sizeType="s">
              <span className="tw-text-standardText-secondary">更新日：</span>
              {formatDate(asset.uploadedAt, 'YYYY/MM/DD, hh:mm')}
            </Txt>
            {(asset.contentType === 'img' ||
              asset.contentType === 'pdf' ||
              asset.contentType === 'video') && (
              <Txt sizeType="s">
                <span className="tw-text-standardText-secondary">サイズ：</span>
                {getFileSize(asset.fileSize)}
              </Txt>
            )}
          </div>
        }
        showIcon={false}
      >
        <Container
          className="tw-w-[1.5rem] tw-aspect-square hover:tw-bg-surface-secondary tw-rounded-full tw-centering"
          type="button"
        >
          <Icon
            size="--r0"
            path="info-circle/soft/line"
            className="tw-text-standardText-disable hover:tw-text-standardText-primary"
          />
        </Container>
      </Tooltip>
    </div>
  )
}
